module.exports = __webpack_public_path__ + "files/group-presentation-slides.pdf";